import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { ProtocoloMassaModalError } from './ModalError';
import { ProtocoloMassaModalForm } from './ModalForm';

const getLabelType = (history) => {
    const match = history.location.pathname.split('/');
    const client = match[1];
    switch(client) {
        case 'formalizacao':
            return 'Contrato';
        default:
            return 'CNPJ';
    }
};

const ProtocoloMassa = ({
    isOpen,
    onClose,
    onCloseError,
    onValidate,
}) => {
    const [shoultShowError, setShoultShowError] = useState(false);
    const [shoultShowForm, setShoultShowForm] = useState(false);
    const [errors, setErrors] = useState([]);
    const { protocolo_massa_erros } = useSelector(({ protocoloEnvio }) => protocoloEnvio);
    const history = useHistory();

    useEffect(() => {
        setShoultShowForm(isOpen);
    }, [isOpen]);

    useEffect(() => {
        setShoultShowError(!!protocolo_massa_erros.length);
        setErrors(protocolo_massa_erros);
    }, [protocolo_massa_erros]);

    const labelType = getLabelType(history);

    const onCloseForm = () => {
        setShoultShowForm(false);
        !!onClose && onClose();
    };

    const onCloseErrorHandler = () => {
        setShoultShowError(false);
        !!onCloseError && onCloseError();
    };

    const onSend = (numeros) => {
        setShoultShowForm(false);
        onValidate(numeros);
        !!onClose && onClose();
    };

    return (
        <React.Fragment>
            <ProtocoloMassaModalForm
                isOpen={shoultShowForm}
                labelType={labelType}
                onClose={onCloseForm}
                onSend={onSend}
            />
            <ProtocoloMassaModalError
                isOpen={shoultShowError}
                labelType={labelType}
                errors={errors}
                onClose={onCloseErrorHandler}
            />
        </React.Fragment>
    );
};

export { ProtocoloMassa };
